import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import moment from 'moment';
import { useAction } from 'hooks';
import { SingleDayPicker } from 'components/DatePickers';
import PopUp from 'components/PopUp';
import App from 'modules/App';
import DateInput from './DateInput';
const DatePicker = ({ id, value, format = 'X', isDisabled = false, disabled, onChange })=>{
    const closePopUp = useAction(App.actions.closeDropdown, `${id}PopUp`);
    const [day, setDay] = useState();
    useEffect(()=>{
        if (day) return;
        const newDay = moment.utc(value, format);
        const isValid = newDay.isValid();
        if (!isValid) return;
        const isAfterDisabled = !disabled || !disabled.before || newDay.isSameOrAfter(disabled.before);
        if (!isAfterDisabled) return;
        const isBeforeDisabled = !disabled || !disabled.after || newDay.isSameOrBefore(disabled.after);
        if (!isBeforeDisabled) return;
        setDay(newDay);
    }, [
        value
    ]);
    const onDateChange = (newDay)=>{
        setDay(newDay);
        const newValue = format === 'X' || format === 'x' ? +newDay.locale('en--account').format(format) : newDay.format(format);
        onChange({
            id,
            value: newValue
        });
        closePopUp();
    };
    return /*#__PURE__*/ _jsxs("div", {
        className: "SingleDatePicker",
        children: [
            /*#__PURE__*/ _jsx(DateInput, {
                id: id,
                momentDate: day,
                disabled: disabled,
                isDisabled: isDisabled,
                onChange: onDateChange
            }),
            /*#__PURE__*/ _jsx(PopUp, {
                id: `${id}PopUp`,
                relativeTo: "modal",
                backgroundColor: "standard",
                noPadding: true,
                children: /*#__PURE__*/ _jsx(SingleDayPicker, {
                    day: day,
                    disabled: disabled,
                    onChange: onDateChange
                })
            })
        ]
    });
};
export default DatePicker;
